// extracted by css-extract-rspack-plugin
export default {"FlexWrapper":"SecondaryEmail_FlexWrapper__gLAUC","OptionsWrapper":"SecondaryEmail_OptionsWrapper__igHPi","SettingsWrapper":"SecondaryEmail_SettingsWrapper__UEbnk"};